<div class="row">
  @if (errorOnExceptionANS$ | async) {
    <div
      data-cy="agentHelpErrorContainer"
      class="column twelve lg-eight lg-push-two md-eight md-push-two"
    >
      <ds-error-message [errorList]="errors"></ds-error-message>
    </div>
  }
  <div class="pad-top-20 row column twelve lg-push-two md-eight md-push-two">
    <h2
      dsContent
      [contentPath]="'policy.quickQuoteNewVehicleAgentsHelpHeader'"
      class="bold-header"
    ></h2>
    <risk-item [riskDescription]="newRiskDescription$ | async"></risk-item>
    <div class="agent-help-body">
      <p dsContent [contentPath]="'policy.quickQuoteNewVehicleAgentsHelpBody'"></p>
    </div>
  </div>

  <div class="row margin-top-50 column twelve lg-push-two md-eight md-push-two">
    <call-to-action
      [displayBackButton]="true"
      tertiaryButtonName="Cancel"
      primaryButtonName="SEND TO MY AGENT"
      (primaryEvent)="sendToAgent()"
      (tertiaryEvent)="cancel()"
      (backEvent)="goBack()"
    ></call-to-action>
  </div>
</div>
<ds-exit-flow-modal
  [exitFlowModalId]="exitFlowModalId"
  [isPartner]="isPartner$ | async"
  (exit)="leave()"
  (cancelModal)="stay()"
  (notifyAgent)="sendToAgent(true)"
></ds-exit-flow-modal>
